var _style, _path, _g, _g2, _path2, _polygon, _polygon2, _g3, _g4, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon0, _polygon1, _polygon10, _polygon11, _polygon12, _polygon13, _polygon14, _defs, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _g5, _g6, _path16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBillPrinting({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "3000px",
    height: "2000px",
    viewBox: "0 0 3000 2000",
    style: {
      enableBackground: "new 0 0 3000 2000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#EBF2F9;}\n\t.st1{fill:#82B479;}\n\t.st2{fill:#A8D29F;}\n\t.st3{fill:#699DEE;}\n\t.st4{fill:#AFCDFB;}\n\t.st5{fill:#FFFFFF;}\n\t.st6{fill:#D86713;}\n\t.st7{fill:#F1A34F;}\n\t.st8{fill:#EE9849;}\n\t.st9{opacity:0.4;fill:#D86713;}\n\t.st10{fill:#E9F3FE;}\n\t.st11{fill:#233862;}\n\t.st12{fill:#4A75CB;}\n\t.st13{fill:#FFB27D;}\n\t.st14{fill:#163560;}\n\t.st15{fill:#C0D8F9;}\n\t.st16{fill:#D4E3F4;}\n\t.st17{clip-path:url(#SVGID_00000161622717788106374550000014297754634608916104_);}\n\t.st18{fill:#E49963;}\n\t.st19{fill:#A8D2A0;}\n\t.st20{fill:#D68D5D;}\n\t.st21{fill:#2B478B;}\n\t.st22{fill:#E7F1FD;}\n\t.st23{fill:#C65447;}\n\t.st24{opacity:0.4;fill:#FFFFFF;}\n\t.st25{fill:#283250;}\n")), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M580.3,1665.6c0,0-291,53.4-383.6-148.7c-120.2-262.3,126.7-461.1,316.1-424.1 c412.6,80.7,313.2-810,975.4-628.2c186.2,51.1,689.3-252.5,829.6,234.3c33.4,115.8,151.6,128.5,323.2,202 c335.8,143.8,182.3,767.1-57.7,769.5C2343.3,1672.9,580.3,1665.6,580.3,1665.6z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2023.3,
    y: 1030.5,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 4217.9453 2699.5312)",
    className: "st1",
    width: 171.4,
    height: 638.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1943.3,
    y: 1030.5,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 4012.4683 2699.5312)",
    className: "st2",
    width: 125.9,
    height: 638.6
  }))), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 2008.3,
    cy: 1601.4,
    r: 28.1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2274.7,
    y: 1030.5,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 4720.7192 2699.5312)",
    className: "st3",
    width: 171.4,
    height: 638.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2194.7,
    y: 1030.5,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 4515.2422 2699.5312)",
    className: "st4",
    width: 125.9,
    height: 638.6
  }))), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 2259.7,
    cy: 1601.4,
    r: 28.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2231.6,
    y: 1095.5,
    className: "st5",
    width: 56.2,
    height: 335.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2523.1,
    y: 1030.5,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 5217.6006 2699.5312)",
    className: "st6",
    width: 171.4,
    height: 638.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2443.1,
    y: 1030.5,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 5012.1235 2699.5312)",
    className: "st7",
    width: 125.9,
    height: 638.6
  }))), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 2508.2,
    cy: 1601.4,
    r: 28.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2480.1,
    y: 1095.5,
    className: "st5",
    width: 56.2,
    height: 335.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1978.1,
    y: 1099.7,
    className: "st5",
    width: 56.2,
    height: 335.2
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1611.9,906.7l60.4,718.4c0,0,6.3,43.5-26.1,43.6c-53.3,0.1-265.1,0-265.1,0s40.1-9.1,39.6-29.5 c-0.6-24-70.6-739.4-70.6-739.4L1611.9,906.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1364,1655.8c10.5,0,212.8,0.7,264.7,0c22.6-0.3,26.6-20.1,26.8-32.9c0.1-6.1-0.7-10.7-0.7-10.7l-1.6-18.7 l-4-47.6l-3.5-42l-4.5-54l-3.8-45.6l-42.9-510.5l-261.8-6.8c0,0,29.5,299.4,50.4,517.3c2.3,24.3,4.5,47.6,6.6,69.3 c0.7,6.9,1.3,13.7,1.9,20.3c1.9,20.6,3.7,39.6,5.2,56.3c0.8,8.8,1.6,17,2.2,24.5c2.7,29.4,4.2,48.2,4.2,51.7c0,2.1-0.2,4-0.5,5.8 C1398.3,1655,1367.9,1655.8,1364,1655.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "990.9,515.8 2247.6,515.8 2100.4,1107 2080.3,1187.9 2011.7,1463.3 738.2,1463.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "2247.6,515.8 2268,522.6 2038.8,1483.9 2011.7,1463.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "2038.8,1483.9 773.2,1483.9 738.2,1463.3 2011.7,1463.3  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1320.3,
    y: 1656,
    className: "st7",
    width: 274,
    height: 13
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "1390,1483.8 1391.4,1493.8 1649.1,1545.9 1645.6,1503.8 1643.9,1483.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M1364,1655.8c10.5,0,212.8,0.7,264.7,0c22.6-0.3,26.6-20.1,26.8-32.9l-256.5-48.3c2.7,29.4,4.2,48.2,4.2,51.7 c0,2.1-0.2,4-0.5,5.8C1398.3,1655,1367.9,1655.8,1364,1655.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "1468.8,1277.1 2011.7,1463.3 2058.1,1277  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "990.9,515.8 2247.6,515.8 2058.2,1277 787,1277.3  "
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1341.2,1373.5c3.6-18.7,21.7-33.8,40.4-33.8c18.7,0,30.9,15.1,27.2,33.8c-3.6,18.7-21.7,33.8-40.4,33.8 C1349.8,1407.4,1337.6,1392.2,1341.2,1373.5z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "846.2,1244.3 2022.9,1244.3 2156.2,713.4 2166.4,672.7 2175.1,638 2195.5,556.6 1035.8,556.6  1013.4,638 1003.8,672.7 992.6,713.4  "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "1035.8,556.6 2195.5,556.6 2175.1,638 1013.4,638  "
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M2139.9,583.2c5.6,0,9,4.6,7.6,10.2s-7.1,10.2-12.7,10.2c-5.6,0-9-4.6-7.6-10.2S2134.3,583.2,2139.9,583.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M2106.1,583.2c5.6,0,9,4.6,7.6,10.2s-7.1,10.2-12.7,10.2s-9-4.6-7.6-10.2 C2094.8,587.7,2100.5,583.2,2106.1,583.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M2057,593.4c1.4-5.6,7.1-10.2,12.7-10.2c5.6,0,9,4.6,7.6,10.2c-1.4,5.6-7.1,10.2-12.7,10.2 S2055.6,599,2057,593.4z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "man_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M421.5,1595.9c0,0-15,13.9-12.1,23.7c2.9,9.9,16.4,16.4,18.3,28.5c1.8,12.1,9.1,18.6,15.7,18.6 c6.6,0,31.4,0,31.4,0s4.8-8.5-6.9-11c-11.7-2.6-16.1-16.7-15.4-29.9c0.7-13.2-1.1-30.7-1.1-30.7l-24.8-5.8L421.5,1595.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M693,1666.7h-83.3c-0.7-0.2-1.3-0.3-1.6-0.5c-5.5-2.8-3.8-24-3.1-30.6c0.1-1.2,0.2-1.9,0.2-1.9 s29.2-23.4,33.2-5.5c0.1,0.6,0.3,1.1,0.4,1.6c5.1,16.7,27.7,24.4,40.8,26.5C689.7,1658,692.3,1663.8,693,1666.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M676.3,1187.4c0,0-4.4,55.4-9.7,122c-7.1,90.4-15.6,201.5-16.5,222.6c-1.5,36.5-7.3,95-7.3,95 s-13.9,13.9-41.6,8c0,0-24.7-83.4-31.8-171.7c-0.1-1.4-0.2-2.9-0.3-4.4c-6.6-89.9-16.8-279.1-16.8-279.1L676.3,1187.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M676.3,1187.4c0,0-4.4,55.4-9.7,122l-97.2,153.9c-0.1-1.4-0.2-2.9-0.3-4.4c-6.6-89.9-16.8-279.1-16.8-279.1 L676.3,1187.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M656,1194c0,0-80,200.6-132.6,294.8c-52.6,94.3-69,120.6-69,120.6s-30.1-12.1-32.9-20.3 c0,0,20.1-182,55.3-226.3c19.9-25.1,43.3-100.3,44.4-126.6c1.1-26.3,7.1-78.4,7.1-78.4L656,1194z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M736.9,1138.6l4.6,9.1c0,0,23.3,3.2,16.9,27.5c0,0-3.4,10-9.9,6.8c-6.4-3.2-3.3-2.9-12.4-7.1 c-9.2-4.2-14.5-12.4-12.5-19.9l-1.5-7.9L736.9,1138.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M615,884.4c3.6-21,3.7-33.5,3.7-33.5L578,818.2c1.5,45-27.3,66.6-27.3,66.6s54.1,26.6,85.4,16.8 C636.1,901.6,628.4,891.8,615,884.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M628.2,850.2c0,0-51.6,8.6-56.5-23.7c-4.8-32.2-14.8-52.8,18-59.7c32.8-6.8,41,4.5,45.3,14.9 C639.2,792.1,641.5,847.2,628.2,850.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M572,828.8c0,0,1-43.2,48.1-50.1c32.2-4.7,12.7-31.7,9-35.9c0,0-24.6,4.7-49.9,10.2 C526.4,764.6,566.4,822.4,572,828.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M731.5,1151.3c6.9-7.1,12-16.3,12-16.3s-58.7-72.9-63.4-80.5c-4.8-7.6-40.4-128.8-40.4-128.8l-90.1-18.3 c0,0,75.2,155.2,87.7,174.1c20.6,31.3,82.2,77.8,82.2,77.8S726.1,1156.9,731.5,1151.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M679.7,1192c-0.9,0.8-2,1.3-3.3,1.3c-11.7-0.2-46,6.4-74.9,3.4c-24.4-2.3-46-9.6-69.2-20 c-3.1-1.4-10.2-5.2-10-8.6c0.1-3.8,0.5-9.2,0.9-16.1c1.6-24,4.5-65.2,1.7-112.7c-0.5-8.9-0.8-17.6-0.8-26.3 c-0.2-64.4,12.3-121.4,38-140.6c2.2-1.6,15.9,5.3,28.2,11.4c11.4,5.6,19.4,5.5,30.2,3.3l14.2,10.3c13.2,12.2,27.6,28.8,33.8,54 c5.3,21.4,8.5,60.1,10.2,100.2c0.8,18.2,1.4,36.5,1.6,53.9v0.6c0.2,1.7,0.2,3.6,0.2,5.3C681.1,1156,680.5,1191.4,679.7,1192z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M523.2,1151.9c1.6-24,4.5-65.2,1.7-112.7c-0.5-8.9-0.8-17.6-0.8-26.3c10.7-25.9,19.4-44.8,19.4-44.8h27 C570.5,968.2,590.2,1103.2,523.2,1151.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M470.7,1160.3l-5.1,8.8c0,0,10,21.2-13.8,29.2c0,0-10.2,2.6-11.1-4.5c-0.9-7.1,0.6-4.3-0.9-14.3 c-1.5-10,2.4-18.9,9.8-21.3l5.8-5.6L470.7,1160.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M457.1,1162.8c9.7,1.9,20.2,1.1,20.2,1.1s28.8-89,32.5-97.2c3.7-8.1,85.6-104.4,85.6-104.4l-34.1-85.4 c0,0-88.6,148-97.6,168.8c-14.9,34.4-20,111.4-20,111.4S449.5,1161.3,457.1,1162.8z"
  })))), /*#__PURE__*/React.createElement("g", null, _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "1491.3,1124.3 941.9,1124.3 1129.7,364.6 1679,364.6  "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "1409.2,1076.9 859.9,1076.9 1047.7,317.2 1597,317.2  "
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "1320.3,1022.7 771,1022.7 958.7,263 1508.1,263  "
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "1585.8,364.6 1412,1072.4 955.3,1076.9 1425.8,1087.3  "
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "1494.6,317.2 1329.4,1018.2 872.8,1022.7 1337.2,1034.2  "
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "1091.4,526.3 937.8,526.3 985.9,333.3 1139.5,333.3  "
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "1442.2,360 1166.9,360 1173.7,333.3 1448.9,333.3  "
  })), _polygon0 || (_polygon0 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "1429.7,414.7 1154.5,414.7 1161.3,388 1436.5,388  "
  })), _polygon1 || (_polygon1 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "1416.8,469.4 1141.5,469.4 1148.3,442.8 1423.5,442.8  "
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "1401.5,524.2 1126.3,524.2 1133,497.5 1408.3,497.5  "
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "1401.5,581.2 897.6,581.2 904.4,554.5 1408.3,554.5  "
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "1388.1,638.2 884.2,638.2 891,611.5 1394.8,611.5  "
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "1369.4,702.3 865.6,702.3 872.3,675.7 1376.2,675.7  "
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "1352.5,757.8 848.6,757.8 855.4,731.1 1359.3,731.1  "
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_1_",
    points: "1091.4,526.3 937.8,526.3 985.9,333.3 1139.5,333.3  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000041981077498315883080000011958707307252757397_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000041981077498315883080000011958707307252757397_)"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M1104.8,545.5c0,0,9-4.1,12.5-2.9c3.5,1.3,13.1,5.4,12.8,9.5c-0.2,4.1-15.5,8.7-25.8,3.7 C1094.2,550.8,1104.8,545.5,1104.8,545.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M1107.5,556.8c-0.2,0.5-0.4,1-0.6,1.4c-3,4.9-53,5.1-58.7,1c-2.6-1.8-3.3-27.1-3.4-54.5 c-0.1-33.8,0.9-70.9,0.9-70.9s19.5,9.1,20.5,20.2c1,11.2-7.3,78.2-1.6,82.3c5.7,4.1,32,4.6,40.8,7.2 C1105.4,543.6,1109.1,551.7,1107.5,556.8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M1057,356.9c-3.4-3.6-9-3.9-12.6-4.1c1-0.8,2.9-0.9,2.9-0.9c-2.2-0.6-7.4,0.9-7.4,0.9s-17.4-12-29.3,11.4 c0,0,1.7-1.7,4-3.5c-6.8,13.5-4.5,35.5,10.7,41.3C1035.3,405.8,1092,393.4,1057,356.9z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M1046.4,439.5c0.1,0.1-10.6,3.9-17.8,0.9c-6.8-2.8-10.2-12.6-10.1-12.6c3.1-0.2,4.5-4.2,6.7-21.9l1.3,0.4 l22.2,7.4c0,0-1.4,7.1-2.3,13.8C1045.6,433.3,1045.2,438.7,1046.4,439.5z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1048.6,413.8c0,0-1.4,7.1-2.3,13.8c-12.7-2-17.9-14.5-19.8-21.3L1048.6,413.8z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M1024.5,403.6c0,0-5.3-11.4-5.7-20.6c-0.3-6.6,6.1-30,29.6-23.5c0,0,6.9,1.6,12.8,6.9 c4.7,4.2,11.3,12.7,0.2,32.5l-3.1,6.7L1024.5,403.6z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M1052.1,420.7c0,0-30.2-3.4-27.8-22.2c2.4-18.8,0.1-31.8,19.5-30.4c19.4,1.4,22.2,9,22.9,15.5 C1067.4,390,1060,421.1,1052.1,420.7z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1054,463.2c-0.2-2.2,4.5-3.2,5.3-1.2c1.6,3.8,1.4,8.4,1.8,12.1c1,10.5-3.1,24.2-3.1,24.2L1054,463.2z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M1067.2,373.1c-3.9-6.2-7.6-5.5-9.8-4c-5.2-10.6-27.6,0.8-27.6,0.8c-3.8,13.2-14.5,19.6-14.5,19.6 s5,4.1,18.1,2.5c10.3-1.3,19.3-14.5,22.7-20.1c1.6,1.8,4.9,6,5.5,9.7c0.9,5,0.3,14.9,3.2,14.9 C1064.9,396.6,1073,382.4,1067.2,373.1z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1046.8,408.5c0,0,0.3,2.5,6.2,2.9c0,0,5,0.3,5.2-2.3C1058.3,409,1053.7,406.6,1046.8,408.5z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1107.5,556.8c-0.2,0.5-0.4,1-0.6,1.4c-3,4.9-53,5.1-58.7,1c-2.6-1.8-3.4-33.2,3.7-60.3 c1.7,16.2-1.4,48.7,7.1,51.3C1068.6,553.2,1094.9,553.3,1107.5,556.8z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M1059.7,499.8c-19.8,57.2-10.8,67.6-17.9,72.5c0,0-5.9,1.7-6,1.7c-7.3,4.9-6.6-2.1-28.5,4.2 c-10.4,3-23.9,7-35.4,9c-4.3,0.7-8.4,1.1-11.9,1.1c-6.8-0.1-11.6-1.9-12.6-6.6c-3-13.7,24.1-45.6,21.6-70c0-0.2,0-0.4-0.1-0.6 c-0.1-2.1,0.1-4.5,0.6-7.1c2.8-13.1,13.6-31.3,24.4-46.6c11.9-16.9,23.8-30.3,24.6-29.7c23.3,18.2,27.2,6.1,27.2,6.1 S1066.5,480.3,1059.7,499.8z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1037.9,573.5C1037.9,573.5,1038,573.5,1037.9,573.5c-7.3,4.9-8.7-1.5-30.7,4.8c-10.4,3-23.9,7-35.4,9 c-5.8,0.3-10.1,0.6-11.9,1.1c-6.8-0.1-11.6-1.9-12.6-6.6c-3-13.7,24.1-45.6,21.6-70c0-0.2,0-0.4-0.1-0.6 c-0.2-2.4,0.1-4.8,0.6-7.1c2.5-9.9,11.3-19.9,21.8-34.7c4.8,6.6,47.8,5.2,30.3,62.5C1016.1,549.3,1037.1,559.3,1037.9,573.5z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M1035.5,576.2c0,0,9.6-1,13.6,1.3c4,2.3,11.9,7.8,10.9,10c-1.1,2.3-11.3,2.2-15.3-0.7 c-3.9-2.9-7.5-0.3-12.4-2.7C1027.3,581.7,1035.5,576.2,1035.5,576.2z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M1018.5,427.8c0,0-34.3-4-42.6,11.7c-8.3,15.7-13.9,74-7.2,92.6c6.7,18.6,54.6,48.8,60.2,50.5 c5.5,1.7,10.2-6.6,10.1-7.6c-0.1-1-47.8-51.1-47-55.5C992.7,515.1,1018.5,427.8,1018.5,427.8z"
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "2164,1576.7 2151.8,1628.3 2133.4,1628.2 2132.8,1576.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "2009.7,1578.9 1974.8,1628.3 1961.3,1610.8 1982.2,1572.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M2100.3,898.8c6.3-3.6,13.9-4,19.2-3.7c-1.4-1.4-4.1-1.9-4.1-1.9c3.3-0.5,10.6,2.8,10.6,2.8 c45.8-17.6,53,49.8,52,65.4c-1,15.7,15.4,20.8,39.2,33.1c45.5,23.5,49.4,55.1,49.4,55.1c-0.4,0.2-0.7,0.4-1.1,0.7 c-2.3-3.8-6.9-11-10.8-12.1c0.1,0.3,4.6,9.9,6.3,15.3c-13.4,10.2-38.5,32.8-56,48.8c0.1-3.1,0-7.6-1.2-9.9l-2.2,13 c-9.4,8.6-15.8,14.7-15.8,14.7c1.2-12.7-57.3-79.5-87.7-99.5c-7.4-10.9-10.1-30.2-10.3-31.7c1.3,15.3,3.9,23.9,6.2,28.7 C2068.5,993.9,2083.5,908.3,2100.3,898.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M2100.1,1021.7c-0.2,0.1,14.7,7.8,25.9,4.7c10.5-2.9,17.4-16.5,17.2-16.5c-4.5-0.9-5.7-7-5.6-33.3l-2,0.4 l-33.9,6.7c0,0,0.8,10.7,0.8,20.7C2102.6,1012.8,2102,1020.8,2100.1,1021.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M2101.7,983.7c0,0,0.8,10.7,0.8,20.7c18.9-0.5,29-17.8,33.1-27.4L2101.7,983.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M2139.1,973.3c0,0,9.9-15.7,12.3-29.1c1.7-9.6-3.2-45.1-38.8-40c0,0-10.4,1-20.1,7.6 c-7.7,5.2-18.9,16.5-6.4,47.5l3.2,10.5L2139.1,973.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M1966.8,1597.3l17.9,0.5l19.4,0.6c0,0,44.9-50,70-130c0.6-1.9,1.2-3.7,1.9-5.7 c13.8-40.2,42.3-90.6,57.4-136.2c2.4-7.3,4.5-14.1,6.5-20.6c0.6-2.1,1.2-4.1,1.8-6.1c11.1-38.5,14.3-63.8,17.3-90.9l-108.7,0.9 C2050.3,1209.8,2032.8,1394.4,1966.8,1597.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M2065.5,1147.4c0.3,51.7-7.6,73.9-7.6,73.9s46.5,23.6,101.8,6.2c0.7-0.2,41.6-8.4,41.6-8.4 c-0.9-2.1-12.2-37.9-13.1-39.8c-11.7-25.1-13.3-37.2-14.7-44.9c-2.6-14.4-2.6-29.3-1.3-43.3c3.4-37.2,13.4-68,13.4-68 c-15.1-3.4-29.2-9.5-44.9-15.3c-3.6,4.5-14.6,9.2-24.2,9c-11-0.2-14.6-5-14-10.1c-11.7,6.5-21.1,12.7-21.1,12.7 c-10,17.3-30.2,34.2-31.7,60.7C2049.4,1086.5,2065.5,1145.9,2065.5,1147.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M2002.4,1070.6c16-18.6,57.3-59,99.9-64l-36.8,71.7c0,0-2.1,12.3-13,19.4c-26.7,17.5-60.6,25.3-60.6,25.3 s-23-10-54.4-33.1c-9.9-7.2-27.2-34.8-27.2-34.8l4.7-15.6c0,0,29.4,16.5,39.9,21.2c6,2.7,19.8,9.2,29.5,13.7 C1990.6,1077.3,1998,1075.7,2002.4,1070.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M2095.4,993.2c0,0,44.8,0.7,44.9-27.2c0-27.9,5.8-46.6-22.8-48.3s-34.2,9-36.5,18.3 C2078.7,945.3,2083.8,992.3,2095.4,993.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M2097.1,917c0,0,12.3,32.8,31.1,37.6c18.8,4.8,27-0.2,27-0.2s-14.4-11.5-17.4-31.5 C2137.7,922.9,2106.3,901.4,2097.1,917z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M2100.1,919.7c0,0-9.2,7.3-11.4,14.4c-2.2,7.1-3.2,21.7-7.5,21.3c0,0-9.2-22.3,1.1-34.9 C2093.4,907.1,2100.1,919.7,2100.1,919.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M1915,1039.5c0,0-6.3-22.8-31.4-19.6c-2.9,0.9-11.3,4.2-5.9,13.2c4,6.6,5.7,3.2,11.9,12.1 c6.2,8.9,13,10.9,20.7,9.9L1915,1039.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M2152.4,1625.4c0,0-1.5,10.2,2.3,21.2c0,0,3,13.7-10.5,13.9c-13.5,0.3-16.8-1-15.3-9.4 c1.5-8.4,4.4-22.9,4.4-22.9L2152.4,1625.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M2127.7,1666.3c0,0,0.3,0.2,0.8,0.4h26.4c0.5-0.3,0.7-0.4,0.7-0.4c1.5-6.9-1-19.8-1-19.8 c-15.3,14-24.8-0.3-24.8-0.3C2127.4,1652.2,2127.7,1666.3,2127.7,1666.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M1928.8,1652.4c0,0,24.8-27.6,32.5-41.6l18.5,9.5l-41.3,38.8l-9.7-1.3L1928.8,1652.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1913.4,1666.8h34c3.3-2.4,6.3-8.1,10.1-15.7c2-4.1,6.6-6.3,11.2-7.5v23h7.1l6.7-24.4 c4.4-8.1,0.3-15.4-2.8-21.8c-3.6,0-13.3,2.5-31.6,23.1c-6,6.8-12.7,9.2-19.3,9c-0.1,0.1-0.2,0.1-0.3,0.1 C1917.5,1657.6,1914.3,1663.7,1913.4,1666.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M2102.6,1006.6c0,0-25.9,64.1-26.7,77c-0.8,13-3.1,212-3.1,212s1.5,9.2-16,5.3c-17.5-3.8-22.1-7.6-22.1-7.6 s16.8-122.8,12.2-165.5c-4.6-42.7,35.1-112.4,35.1-112.4L2102.6,1006.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M1984.7,1597.8l19.4,0.6c0,0,44.9-50,70-130c0.6-1.9,1.2-3.7,1.9-5.7c13.8-40.2,42.3-90.6,57.4-136.2 c2.4-7.3,4.5-14.1,6.5-20.6c0.6-2.1,1.2-4.1,1.8-6.1l-16-12.1c0,0-48,77.8-62.9,151C2049.9,1502.3,1998.1,1578.8,1984.7,1597.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M2124,1445.5c-0.3,35.6,1.5,117.5,6.2,151.3h17.2c9.5,0,14.3-0.1,14.3-0.1c11.6-58.9,19.9-107.7,25.9-149.7 c4.9-34.5,9.3-64,12.7-89.5c3.4-25.6,5.8-47,6.6-65.2c0.1-2.9,0.2-5.6,0.3-8.3c0.1-2.7,0.1-5.3,0-7.9l-93.9-9.2 C2114.6,1329.4,2124.2,1424.8,2124,1445.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M2147.4,1596.9c9.5,0,14.3-0.1,14.3-0.1c11.6-58.9,19.9-107.7,25.9-149.7c4.9-34.5,9.3-64,12.7-89.5 c3.4-25.6,5.8-47,6.6-65.2l-34.5,20.3c0,0,22,7.8,13.6,66.5C2177.7,1437.9,2159.1,1588.5,2147.4,1596.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M2143,1291.8c0,0,6.6,23.9,29.5,20.8s55.4-16.8,55.4-16.8s-9.8-30.9-21.9-71.5 c-14.7-49.1-32.9-112.5-41.5-152.5c-2.4-11.2-4.1-20.5-4.7-27.2l-19-36.8c0,0-28.3,63.5-29.8,79.5 C2109.4,1103.4,2143,1291.8,2143,1291.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M2144,1121c1,25.9,7.1,76.3,61.5,103.2c0.1,0.1,0.3,0.1,0.4,0.2c-14.7-49.1-32.9-112.5-41.5-152.5 C2154.4,1086.9,2143.4,1106.7,2144,1121z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1851.4,
    y: 904,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -127.5214 1596.6587)",
    className: "st21",
    width: 24.3,
    height: 96.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M2265.1,1347.8l-6,6c-11.8,11.8-30.9,11.8-42.6,0l-333.9-333.9c-11.8-11.8-11.8-30.9,0-42.6l6-6 c11.8-11.8,30.9-11.8,42.6,0l333.9,333.9C2276.9,1316.9,2276.9,1336,2265.1,1347.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M1425.4,514.1c-111.4,111.4-111.4,292.1,0,403.6c111.4,111.4,292.1,111.4,403.6,0 c111.4-111.4,111.4-292.1,0-403.6C1717.5,402.6,1536.8,402.6,1425.4,514.1z M1806.7,895.4c-99.2,99.2-260,99.2-359.1,0 c-99.2-99.2-99.2-260,0-359.1c99.2-99.2,260-99.2,359.1,0C1905.9,635.5,1905.9,796.2,1806.7,895.4z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M2165.8,1085l-25.1-77.2c0.1,0,31.6,9.4,47.5,17.4c0,0,9.9,12.8,16.1,42.3c0,0,6.5,70.9-8,96.8 c0,0-45.8,9.2-119-16v-16.8c0,0,80.1,4.2,96.5,6.1L2165.8,1085z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M2140.8,1007.9c0,0,46.4,3.3,57.6,28.2c11.2,24.9,14.7,107.8,0.5,132.2c0,0-19.6,5.6-54.3-0.9 c-0.4-0.1-0.9-0.2-1.3-0.2c0,0-11.1-27.1-1.1-32.4c0,0,29.2,1.5,26.2-8.1C2165.4,1116.9,2140.8,1007.9,2140.8,1007.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M2085.6,1136.1c0,0-6.4-7.7-7.7-15.6s-5.6-13.7-16.6-15.2c-11-1.4-15.7-1.6-15.7,1.5c0,3.1,9,24.8,24.8,37.7 C2086.1,1157.4,2085.6,1136.1,2085.6,1136.1z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M1739.6,486.3l-340.1,340.1c5.5,11.2,11.9,22,19,32.2l353.3-353.3C1761.6,498.2,1750.9,491.9,1739.6,486.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M1716.3,476.2c-27.7-10.4-57.7-16-89-16c-140.2,0-253.9,113.7-253.9,253.9c0,31.3,5.7,61.3,16,89 L1716.3,476.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M1514.8,941.9c33.9,16.8,72.1,26.2,112.5,26.2c140.2,0,253.9-113.7,253.9-253.9c0-40.4-9.4-78.6-26.2-112.5 L1514.8,941.9z"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M211.3,1671.4h2577.4c1.3,0,2.3-1,2.3-2.3l0,0c0-1.3-1-2.3-2.3-2.3H211.3c-1.3,0-2.3,1-2.3,2.3l0,0 C209,1670.3,210,1671.4,211.3,1671.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillPrinting);
export default __webpack_public_path__ + "static/media/bill_printing.10ee8a26.svg";
export { ForwardRef as ReactComponent };